import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogHeaderImage } from 'foundations-components/transitional/components/DialogHeaderImage';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { getCmsUrl } from 'web-interactives-data/utils/urlUtils';
import EmbeddingInstructions from './EmbeddingInstructions';
import ExternalPageInstructions from './ExternalPageInstructions';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EmbeddingInstructionsModal = ({
  embedCode,
  onClose,
  illustration,
  title,
  embedCodeFetchError,
  canUseEmail,
  onCopyClick
}) => /*#__PURE__*/_jsxs(Modal, {
  "data-test-id": "embed-info-modal",
  use: "success",
  children: [illustration && /*#__PURE__*/_jsx(DialogHeaderImage, {
    offsetBottom: -23,
    offsetTop: 56,
    children: /*#__PURE__*/_jsx(Illustration, {
      name: illustration,
      width: "110px"
    })
  }), /*#__PURE__*/_jsxs(DialogHeader, {
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h2",
      textAlign: "center",
      children: title || /*#__PURE__*/_jsx(FormattedMessage, {
        message: "embeddingInstructions.modal.title"
      })
    }), /*#__PURE__*/_jsx(DialogCloseButton, {
      onClick: onClose
    })]
  }), /*#__PURE__*/_jsx(DialogBody, {
    paddingBlockStart: "1000",
    children: /*#__PURE__*/_jsx(EmbeddingInstructions, {
      embedCode: embedCode,
      embedCodeFetchError: embedCodeFetchError,
      canUseEmail: canUseEmail,
      children: /*#__PURE__*/_jsx(ExternalPageInstructions, {
        hasError: embedCodeFetchError,
        embedCode: embedCode,
        onCopyClick: onCopyClick
      })
    })
  }), /*#__PURE__*/_jsxs(DialogFooter, {
    paddingBlockStart: "1000",
    children: [/*#__PURE__*/_jsx(Button, {
      onClick: onClose,
      use: "primary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "embeddingInstructions.modal.actions.done"
      })
    }), /*#__PURE__*/_jsx(Button, {
      href: getCmsUrl(),
      use: "secondary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "embeddingInstructions.modal.actions.visitCms"
      })
    })]
  })]
});
export default EmbeddingInstructionsModal;